//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconNavMenu(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M20 6H4V8H20V6Z" fill="currentColor" /><path d="M20 11H4V13H20V11Z" fill="currentColor" /><path d="M20 16H4V18H20V16Z" fill="currentColor" /></svg>;
}
export default IconNavMenu;